import Raven from 'raven-js';

/**
 * Initializes Google analytics
 * @param  {String} id  analytics id without 'UA-', e.g.: '12345678-1'
 */
const init = function(id) {

    window.ga = window.ga || function() {
        ( window.ga.q = window.ga.q || [] ).push(arguments)
    }

    window.ga.l = +new Date

    if ( id === '') {
        console.log('Tracking disabled')
    } else {
        window.ga('set', 'forceSSL', true)
        window.ga('set', 'anonymizeIp', true)
        window.ga('create', 'UA-' + id, 'auto')
    }
}

const event = function(category, action, label, value) {
    window.ga('send', 'event', category, action, label, value)
}

const pageview = function(path) {
    if ( path != null ) {
        window.ga('set', 'page', path);
    }
    window.ga('send', 'pageview');
}

/**
 * Track application error
 * @param  {String} message description of error
 * @param  {Error} err     Error or extra data
 * @param  {Object} data    extra data
 */
const exception = function(message, err, data) {

    console.error(message, err)
    if ( !shouldReport(err) ) {
        return
    }

    if ( err instanceof Error ) {
        Raven.captureException(err, { extra: Object.assign({message: message}, data) })
    } else {
        const errorObj = formatException(err) || {}
        Raven.captureException(new Error(message), { extra: Object.assign(errorObj, data) })
    }

}

/**
 * Starts tracking user
 * @param  {String} id  id of the logged in user, null to reset
 */
const user = function(id) {
    let context = id == null ? null : { id: id }
    Raven.setUserContext(context)
}

function shouldReport(err) {
    const responseStatusCodeBlacklist = [ 0, 1, 401, 403, 410, 422, 429 ]
    return !isResponse(err) || responseStatusCodeBlacklist.indexOf(err.status) === -1
}

export function isResponse(data) {
    return data != null
        && !(data instanceof Error)
        && data.status != null
        && data.url != null
        && (data.body !== undefined || data.response !== undefined)
}

function formatException(data) {
    if (isResponse(data)) {
        return { status: data.status, errors: data.body ? data.body.errors : data.response, url: data.url}
    }

    return data
}

export default {
    init,
    event,
    pageview,
    exception,
    user,
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/analytics.js